import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Foso/imprimirFoso`, method: 'POST', body: values, token: token})
}
